import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconHeadingComponent } from "./med-icon-heading.component";

@NgModule({
  declarations: [
    MedIconHeadingComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconHeadingComponent,
  ],
})
export class MedIconHeadingModule { }
